const Project = ({ project, side }) => {
	return (
		<div className={`project ${side}`}>
			<div className="project__content">
				<h3>{project.title}</h3>
				<p className="type">{project.type} Project</p>
				<p className="copy">{project.copy}</p>
				<a href={project.links[0]} target="_blank" rel="noreferrer">
					Visit Site
				</a>
			</div>
			<div className="project__image">
				<img src={`/img/${project.img}`} alt="" />
			</div>
		</div>
	);
};

export default Project;
